/** Ease `current` toward `target`. `k` is the per-frame blend at 60fps. */
export function stepToward(current, target, delta, reducedMotion, k = 0.09) {
  if (current == null) return target;
  if (reducedMotion) return target;
  const next = current + (target - current) * (1 - Math.pow(1 - k, Math.max(delta || 0.016, 0) * 60));
  return Math.abs(next - target) < 0.004 ? target : next;
}

/** Selected glow eases on — a bloom, not a scale snap. */
export function stepSelectLerp(current, selected, delta, reducedMotion) {
  return stepToward(current, selected ? 1 : 0, delta, reducedMotion, 0.09);
}
